import { Component, input, inject } from '@angular/core';
import { Supplier } from '../../shared/classes/supplier';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../shared/services/auth.service';

@Component({
    selector: 'app-account',
    templateUrl: './account.component.html',
    styleUrls: ['./account.component.css'],
    imports: [FormsModule]
})
/**
 * The account page which has options to modify the current user's account.
 */
export class AccountComponent {
    private authService = inject(AuthService);

    readonly supplier = input.required<Supplier>();

    /**
     * Removes the tokens from local storage and refreshes the page (will be unauthenticated).
     */
    signOut(): void {
        this.authService.logout();
    }
}
